module.exports = __webpack_public_path__ + "static/img/button_icon1.fdd47875.png";